import React, { useState } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const tasks = [
    {
        text: "Say one more and one less than",
        check: (num, input) => {
            const [more, less] = input.split(",").map(x => parseInt(x.trim()));
            return more === num + 1 && less === num - 1;
        },
    },
    {
        text: "Double the number",
        check: (num, input) => parseInt(input) === num * 2,
    },
    {
        text: "Say 10 more than",
        check: (num, input) => parseInt(input) === num + 10,
    },
    {
        text: "Count on by 3s (give 3 numbers)",
        check: (num, input) => {
            const parts = input.split(",").map(x => parseInt(x.trim()));
            return (
                parts.length === 3 &&
                parts[0] === num + 3 &&
                parts[1] === num + 6 &&
                parts[2] === num + 9
            );
        },
    },
];

export default function NumberSplash() {
    const [currentNumber, setCurrentNumber] = useState("?");
    const [currentTask, setCurrentTask] = useState(null);
    const [challengeText, setChallengeText] = useState('Press "Start" to begin!');
    const [answer, setAnswer] = useState("");
    const [message, setMessage] = useState("");
    const [hasStarted, setHasStarted] = useState(false);

    const startRound = () => {
        const number = Math.floor(Math.random() * 51);
        const task = tasks[Math.floor(Math.random() * tasks.length)];

        setCurrentNumber(number);
        setCurrentTask(task);
        setChallengeText(`${task.text} ${number}`);
        setAnswer("");
        setMessage("");
        setHasStarted(true);
    };

    const checkAnswer = () => {
        if (!currentTask) return;
        const correct = currentTask.check(currentNumber, answer);
        setMessage(correct ? "✅ Correct!" : "❌ Try again!");

        if (correct) {
            const responsedata = ConstructorEventUpdateSQLStatus();
            console.log("Event completed", responsedata);
        }
    };

    return (
        <div style={styles.body}>
            <h1 style={styles.h1}>Number Splash! 🌊</h1>
            <div style={styles.card}>{currentNumber}</div>
            <div style={styles.challenge}>{challengeText}</div>

            {hasStarted && (
                <>
                    <input
                        type="text"
                        value={answer}
                        onChange={e => setAnswer(e.target.value)}
                        placeholder="Your Answer"
                        style={styles.input}
                    />
                    <div style={styles.buttonRow}>
                        <button onClick={checkAnswer} style={styles.button}>Submit</button>
                        {message && (
                            <button onClick={startRound} style={styles.button}>Next</button>
                        )}
                    </div>
                </>
            )}

            {!hasStarted && (
                <div>
                    <button onClick={startRound} style={styles.button}>Start</button>
                </div>
            )}

            <div style={styles.message}>{message}</div>
        </div>
    );
}

const styles = {
    body: {
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        backgroundColor: "#e0f7fa",
        padding: "30px",
        minHeight: "100vh",
    },
    h1: {
        color: "#00796b",
    },
    card: {
        fontSize: "50px",
        margin: "20px",
        padding: "20px",
        background: "#ffffff",
        border: "4px solid #00796b",
        borderRadius: "15px",
        display: "inline-block",
        minWidth: "100px",
    },
    challenge: {
        fontSize: "20px",
        margin: "20px 0",
    },
    input: {
        fontSize: "18px",
        padding: "8px",
        width: "150px",
        margin: "0 auto",
        display: "block",
    },
    buttonRow: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginTop: "10px",
    },
    button: {
        padding: "10px 20px",
        fontSize: "18px",
        margin: "10px",
        background: "#00796b",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    message: {
        fontSize: "18px",
        marginTop: "15px",
        fontWeight: "bold",
    },
};
